import { IconButton, Tooltip } from '@dixa/lib-shared-habla';
import { ampli } from 'lib-shared-tracking';
import { useCallback } from 'react';

import { appActions } from 'app/app.actions';
import { useAppDispatch } from 'utils/redux/useAppDispatch';

import { useConversationRow } from '../../../../../utils/useConversationRow';

/**
 * Represents the component for displaying the preview button in the
 * conversations table row.
 */
export const ConversationsTablePreviewButton = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const { conversation } = useConversationRow();

  /** Handles previewing the conversation. */
  const handleClick = useCallback(() => {
    dispatch(
      appActions.showModal({
        modal: {
          type: 'app:conversationPreview',
          arg: { csid: conversation.id },
        },
      }),
    );

    ampli.conversationsItemPreviewClicked();
  }, [conversation, dispatch]);

  return (
    <Tooltip content="Preview conversation" side="left">
      <IconButton icon="eye" variant="tertiary" onClick={handleClick} />
    </Tooltip>
  );
};
